import ObservableAutoSizer from '@vromo/ui/components/ObservableAutoSizer';
import React, { ReactElement } from 'react';
import { JobHistoryModal, JobHistoryResponse } from '../../helpers/JobHistoryHelper';
import useTableStore from '../../helpers/useTableStore';
import ObservableMultiGrid from '../ObservableMultiGrid';

interface Props {
    jobReports: JobHistoryResponse[] | null;
    setSelectedJob: (jobData: JobHistoryResponse) => void;
    setActiveModal: (modalName: JobHistoryModal) => void;
}

const JobHistoryTable = ({
    jobReports,
    setSelectedJob,
    setActiveModal
}: Props): ReactElement | null => {
    const { getColumnWidth, cellRenderer, store } = useTableStore({
        jobHistoryItems: jobReports || [],
        setSelectedJob,
        setActiveModal
    });

    if (!store.sortedJobs.length) return null;

    return (
        <ObservableAutoSizer
            customChildren={({ width, height }) => (
                <ObservableMultiGrid
                    fixedRowCount={1}
                    overscanColumnCount={10}
                    overscanRowCount={40}
                    width={width - 2}
                    height={height - 40}
                    cellRenderer={cellRenderer}
                    rowCount={store.rowCount}
                    columnCount={store.columnCount}
                    rowHeight={32}
                    columnWidth={getColumnWidth}
                />
            )}
        />
    );
};

export default JobHistoryTable;
